import { render, staticRenderFns } from "./cases-create.vue?vue&type=template&id=6f70dc01&scoped=true"
import script from "./cases-create.vue?vue&type=script&lang=js"
export * from "./cases-create.vue?vue&type=script&lang=js"
import style0 from "./cases-create.vue?vue&type=style&index=0&id=6f70dc01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70dc01",
  null
  
)

export default component.exports